/* jshint esversion: 6, -W097 */
/* globals require */

(function(angular) {
    'use strict';
    angular
        .module('enervee')
        .directive('autocomplete', autocompleteDirective);



    function autocompleteDirective() {
        return {
            restrict: 'E',
            scope: {},
            link: autocompleteLink,
            controllerAs: 'vm',
            controller: autocompleteController,
            template: require('@app/shared/search/autocomplete/autocompleteView.html'),
        };
    }

    autocompleteController.$inject = [
        '$q',
        '$scope',
        '$rootScope',
        '$state',
        '$window',
        '$log',
        '$timeout',
        'AnalyticsService',
        'CategoriesService',
        'CmsContentService',
        'UtilService',
        'SearchService',
        'RebatesService',
        'FiltersService',
    ];
    function autocompleteController(
        $q,
        $scope,
        $rootScope,
        $state,
        $window,
        $log,
        $timeout,
        AnalyticsService,
        CategoriesService,
        CmsContentService,
        UtilService,
        SearchService,
        RebatesService,
        FiltersService,
    ) {
        const vm = this;
        vm.utilService = UtilService;
        vm.showPleaseEnterTextPopover = false;
        vm.searchTerm = null;
        vm.completedsearchTerm = null;
        vm.searchResults = [];
        vm.categoriesService = CategoriesService;
        vm.searchService = SearchService;
        vm.isAutocompleteOpen = false;
        const defaultEfficientThreshold = 75;
        vm.isEfficientThreshold = UtilService.getSiteSetting('is_efficient_threshold', defaultEfficientThreshold);
        vm.productLimit = 4;
        vm.searchRan = false;
        vm.showHelpText = false;
        vm.waitBeforeTracking = 1000;
        vm.showRebates = RebatesService.checkShowRebates();
        vm.loadingResults = false;
        vm.numCategoryColumns = 3;
        vm.activeCategoryIcons = null;
        vm.autocompleteIconConfig = [
            {
                name: 'is_rebatable',
                labelCmsKey: 'base:autocomplete_legend:has_rebates',
                showIf: (item) => item.is_rebatable,
                className: 'rebate',
                iconName: 'mp-reward',
                srTextCmsKey: 'index_page:category_has_rebates_sr',
            },
            {
                name: 'is_checkout_enabled',
                labelCmsKey: 'base:autocomplete_legend:has_checkout',
                showIf: (item) => item.is_checkout_enabled,
                className: 'storefront',
                iconName: 'mp-cart-filled',
                srTextCmsKey: 'index_page:category_has_checkout_sr',
            },
            {
                name: 'is_extra_incentive_offered',
                labelCmsKey: 'base:autocomplete_legend:has_extra_incentives',
                showIf: (item) => item.is_extra_incentive_offered,
                className: 'rebate',
                iconName: 'mp-bulb-filled',
                srTextCmsKey: 'index_page:category_has_extra_incentives_sr',
            },
        ];
        let cancelAutocompleteRequest = null;
        const customerSupportKeyphrases = UtilService.getSiteSetting('help_search_keywords', []);

        fetchCategoriesForColumns();
        $rootScope.$on('utilitySet', fetchCategoriesForColumns);

        // get cms search box text
        CmsContentService.getMarketPlaceText('base:autocomplete:search_box_text').then(function(text) {
            vm.searchBoxText = text;
        });
        CmsContentService.getMarketPlaceText('base:autocomplete:please_enter_search_text').then(function(text) {
            vm.pleaseEnterSearchText = text;
        });
        CmsContentService.retrieveCMSValue(vm, 'loaderText', 'base:autocomplete:loading_text');
        CmsContentService.retrieveCMSValue(vm, 'inputPlaceholder', 'base:search:input_placeholder');

        const filtersToTranslate = [
            'text',
            'query'
        ];

        vm.urlFilterText = 'filters';
        vm.urlQueryText = 'query';
        FiltersService.getTranslatedFilterCodes(filtersToTranslate).then(function (data) {
            vm.urlFilterText = data.text;
            vm.urlQueryText = UtilService.getKeyByValue(data, vm.urlQueryText);
        });

        /**
         * This watches the is autocomplete open function in SearchService. If the autocomplete overlay
         * is open, we need to focus the input. If it is closed, we want to clear out the search term
         * and any results.
         */
        $scope.$watch(function (scope) {
            return scope.vm.searchService.isAutocompleteOpen()
            },
            function (newValue) {
                vm.isAutocompleteOpen = newValue;
                if (!newValue) {
                    vm.loadingResults = false;
                    vm.searchTerm = null;
                    vm.searchResults = [];
                    vm.searchRan = false;
                    if (cancelAutocompleteRequest !== null) {
                        cancelAutocompleteRequest.resolve();
                    }
                } else {
                    AnalyticsService.reportEvent('Autocomplete Viewed');
                    cancelAutocompleteRequest = $q.defer();
                }
            }
        );

        /**
         * Fires when a user clicks a result from the list. Tracks what product the user selected.
         *
         * @param product
         */
        vm.trackGoToResult = function (product) {
            vm.trackEngagement({
                category: product.category.category_code,
                product_click: product.id
            });
        };

        /**
         * Fires on view all category click. Tracks what category the user selected.
         *
         * @param category
         */
        vm.trackGoToCategory = function (category) {
            vm.trackEngagement({
                category: category.category_code,
                view_all_click: true
            });
        };

        /**
         * Tracks category selection in the balanced columns and redirects user to results.
         * @param category
         */
        vm.trackCategorySelectionAndRedirect = (category) => {
            FiltersService.filtersOutputCallbacks = [];
            AnalyticsService.reportEvent('Category Selected', {
                category_name: category.plural_name || category.name,
                category_id: category.id || null,
                location: 'category guide'
            });
            $state.go(category.route || 'results', {
                category_code: category.category_code,
                filters: '',
                sortBy: ''
            });
            $timeout(() => {
                SearchService.closeAutocomplete();
            }, 50);
        };

        /**
         * Generates a view all link for a given category.
         *
         * @param category
         * @returns {*}
         */
        vm.getCategoryLink = function (category) {
            const options = {
                category_code: category.category_code
            };
            options[vm.urlFilterText] = vm.urlQueryText + "=" + vm.searchTerm;
            return $state.href('results', options);
        };

        /**
         * Debounces the search until at least the number of
         * milliseconds defined by `wait`
         * @param wait - the amount of time to wait before running the function
         */
        vm.debounceSearch = function (wait) {
            vm.showPleaseEnterTextPopover = false;
            const search = vm.search;
            UtilService.debounce('autocompleteSearch', function () {
                search(vm.searchTerm);
            }, wait);
        };

        /**
         * Checks to see if the search term contains any of the
         * customer support keywords defined in the
         * `help_search_keywords` site setting.
         *
         * @param {String} searchTerm
         * @return {Boolean}
         */
        const containsCustomerSupportKeywords = function (searchTerm) {
            for (let i = 0; i < customerSupportKeyphrases.length; i++) {
                const keyword = customerSupportKeyphrases[i].toLowerCase();
                if (searchTerm.toLowerCase().includes(keyword)) {
                    return true;
                }
            }
            return false;
        };

        /**
         * Performs search for the given search term
         *
         */
        vm.search = function () {
            vm.showHelpText = false;
            vm.searchRan = false;
            vm.showPleaseEnterTextPopover = false;
            if (vm.searchTerm === null || vm.searchTerm.length === 0) {
                //don't do the search.
                return;
            }

            if (containsCustomerSupportKeywords(vm.searchTerm)) {
                vm.showHelpText = true;
                return;
            }

            const lastSearch = vm.searchTerm;
            vm.loadingResults = true;
            SearchService.performAutocompleteSearch(vm.searchTerm, cancelAutocompleteRequest.promise).then(function success() {
                if (!vm.isAutocompleteOpen) {
                    // autocomplete was closed before the request finished. cancel.
                    return;
                }
                //if previous search got after current ignore it
                if (lastSearch.length < vm.searchTerm.length && vm.completedsearchTerm === vm.searchTerm) {
                    return;
                }
                vm.searchResults = SearchService.getSearchResults();
                if (vm.searchResults.length === 1) {
                    vm.productLimit = 12;
                } else {
                    vm.productLimit = 4;
                }
                const productIds = [];
                vm.flattenedProducts = [];
                vm.searchResults.forEach(function (category, idx) {
                    idx++;
                    category.products.forEach(function (product) {
                        product.category = category.category;
                        productIds.push(product.id);
                        if (vm.flattenedProducts.length < (idx * vm.productLimit) && idx <= 3) {
                            vm.flattenedProducts.push(product);
                        }
                    });
                });
                RebatesService.getRebatesForProducts(productIds).then(function (data) {
                    vm.searchResults.forEach(function (category) {
                        category.products.forEach(function (product) {
                            if (product.id in data) {
                                product.rebates = data[product.id];
                            } else {
                                product.rebates = [];
                            }
                            RebatesService.getRebateTagText(product).then(function (text) {
                                product.rebateTagText = text;
                            });
                        });
                    });
                });
                RebatesService.getRebateLitesForProducts(productIds).then(function (data) {
                    vm.searchResults.forEach(function(category){
                        category.products.forEach(function (product) {
                            if (product.id in data) {
                                product.rebatelite = data[product.id];
                            } else {
                                product.rebateLite = null;
                            }
                        });
                    });
                });
                vm.searchRan = true;
                vm.completedsearchTerm = lastSearch;

                vm.loadingResults = false;
                vm.trackEngagement();
            }, function error(response) {
                $log.warn("Unsuccessful autocomplete api call");
                $log.warn(response.data.message);
            });
        };

        /**
         * Method to handle when user hits Enter key or clicks
         * on the search button. If no search term is entered, show some
         * help text. If no results were found, do nothing. Otherwise,
         * go to results for the first category with the entered query.
         */
        // TODO change this logic to work with new design for 'choose a category' view
        vm.submitSearch = function() {
            if (!vm.searchTerm) {
                vm.showPleaseEnterTextPopover = true;
                return;
            }
            // TODO maybe we need to handle this differently?
            if (vm.searchResults.length === 0) {
                return;
            }
            if (containsCustomerSupportKeywords(vm.searchTerm)) {
                vm.showHelpText = true;
                return;
            }

            const options = {
                category_code: vm.searchResults[0].category.category_code
            };
            SearchService.closeAutocomplete();
            vm.trackEngagement({
                category: options.category_code,
                search_entered: true
            });
            options[vm.urlFilterText] = vm.urlQueryText + "=" + vm.searchTerm;
            $state.go('results', options);
        };

        vm.trackEngagement = function (eventData) {
            eventData = eventData || {};
            eventData.location = 'overlay';
            eventData.query = vm.searchTerm;
            AnalyticsService.reportEvent('Autocomplete Engaged', eventData, vm.flattenedProducts);
        };

        /**
         * Fetches the categories for the autocomplete columns and loads the activeCategoryIcons
         * for the autocomplete legend.
         */
        function fetchCategoriesForColumns() {
            vm.categoryObject = null;
            SearchService.getCategoriesForColumns().then((categoryObject) => {
                vm.categoryObject = categoryObject;
                vm.activeCategoryIcons = SearchService.getActiveCategoryIcons(vm.autocompleteIconConfig);
            });
        }

        getNumCategoryColumns();
        // call below function on page resize.
        angular.element($window).bind('resize', getNumCategoryColumns);

        // break columns into 1, 2 or 3 depending on screen size
        function getNumCategoryColumns() {
            $scope.$applyAsync(() => {
                vm.numCategoryColumns = SearchService.getNumberOfCategoryColumns();
            });
        }
    }

    /**
     * If the autocomplete overlay is open and we detect the escape key, close it.
     *
     * @param scope
     * @param element
     * @param attrs
     */
    function autocompleteLink(scope, element, attrs) {
        const $injector = angular.injector(['ng']);
        const $window = $injector.get('$window');
        angular.element($window).bind('keyup', function(event) {
            scope.$applyAsync(function() {
                const escKeyCode = 27;
                if (scope.vm.isAutocompleteOpen && event.which === escKeyCode) {
                    // esc key. close autocomplete.
                    scope.vm.searchService.closeAutocomplete();
                }
            });
        });
        element[0].onclick = function () {
            scope.vm.utilService.setZIndex('#autocomplete', 50);
            scope.vm.utilService.setZIndex('.category-selector', 49);
        };
    }
})(angular);
